import React from "react";

import { FormFieldWrapperProps } from "./types";
import BaseError from "../FormFields/BaseError";

import "./styles.css";

const FormFieldWrapper = ({
  label,
  description,
  helpText,
  error,
  children,
  required,
}: FormFieldWrapperProps) => {
  return (
    <div className="flex flex-col gap-100 full-width">
      <div>
        <div className="flex flex-wrap items-center gap-100 full-width">
          <h6 className="body-s-medium">
            {label}
            {required && " *"}
          </h6>
          <p className="form-field-wrapper-help-text body-s-regular">
            {helpText}
          </p>
        </div>
        <i className="body-s-regular">{description}</i>
      </div>

      {children}
      <BaseError error={error} />
    </div>
  );
};

export default React.memo(FormFieldWrapper);
